// owner/routes.js — the ONE route table of the owner experience, used by the store app (owner/app/OwnerApp.js)
// and, from the end of 8c, by owners on the web (AppSecure.js), so the two can never drift apart.
// Paths are the web's existing owner addresses: bookmarks and the booking-alert link (/#/bookings/:id,
// be/services/notifications/ownerBookingPolicy.js) keep working unchanged.
// Plan: tasks/owner-mobile-app-build.md §10 step 8 (8c).

import React from 'react';
import { Navigate } from 'react-router-dom';
import Overview from './screens/Overview';
import Units from './screens/Units';
import Unit from './screens/Unit';
import Bookings from './screens/Bookings';
import Booking from './screens/Booking';
import Finance from './screens/Finance';
import Report from './screens/Report';
import Settings from './screens/Settings';

export const OWNER_ROUTES = [
  // 8c batch 1: overview, units, unit. Batch 2: bookings, booking. Batch 3: finance, a report, settings.
  // Guests and guest requests are not part of the owner experience in phase 1 (Adil, 4 Nov 2026,
  // tasks/owner-mobile-app-build.md §10 "8c batch 3"): their old addresses fall through to the overview.
  { path: '/dashboard', element: <Overview /> },
  { path: '/properties', element: <Units /> },
  { path: '/properties/:id', element: <Unit /> },
  { path: '/bookings', element: <Bookings /> },
  { path: '/bookings/:id', element: <Booking /> },
  { path: '/finance', element: <Finance /> },
  { path: '/finance/reports/:id', element: <Report /> },
  { path: '/settings', element: <Settings /> },
  { path: '*', element: <Navigate to="/dashboard" replace /> }
];
